export default `#version 300 es
in vec4 a_position;out vec2 coord;void main(){coord=a_position.xy*0.5+0.5;gl_Position=a_position;}`